// T2T-05-C5 — Notifications REST + SSE URL builder.

import { getData, postData, putData, deleteData, ServerURL } from "../FetchApiServices";
import { getCurrentToken } from "./auth";

const BASE = "t2t/notifications";

export const fetchNotificationFeed = (params = {}) => {
  const q = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null))
  ).toString();
  return getData(`${BASE}/list${q ? `?${q}` : ""}`);
};

export const fetchUnreadCount = () =>
  getData(`${BASE}/unread-count`);

export const markAllRead = () =>
  postData(`${BASE}/mark-all-read`, {});

export const markOneRead = (notificationId) =>
  postData(`${BASE}/${notificationId}/read`, {});

export const deleteNotification = (notificationId) =>
  deleteData(`${BASE}/${notificationId}`);

export const fetchPreferences = () =>
  getData(`${BASE}/preferences`);

export const savePreferences = (body) =>
  putData(`${BASE}/preferences`, body);

// SSE stream — direct-to-backend, query-param auth.
export function buildBellStreamUrl() {
  const token = getCurrentToken() || "";
  const base = (ServerURL || "").replace(/\/$/, "");
  return token
    ? `${base}/${BASE}/sse?access_token=${encodeURIComponent(token)}`
    : `${base}/${BASE}/sse`;
}
